var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.5333C24 20.8667 23.01 21.9567 21.7767 22H21.7L2.3 21.98C1.06 21.98 0.0433333 20.9167 0 19.5933V2H24V19.5333ZM1.50333 3.50333V19.1233C1.50333 19.58 1.50333 20.5033 2.76667 20.52L21.1833 20.4867C22.5033 20.52 22.4733 19.6267 22.5033 19.15V3.50333H1.50333ZM19 15.0033V17.0033H13V15.0033H19ZM7 7.00333V11.0033H11C11 13.3367 9.33333 15.0033 7.03 15.0033C4.72667 15.0033 3 13.3367 3 10.9733C3 8.61 4.33333 7.00333 7 7.00333ZM21 11.0033V13.0033H13V11.0033H21ZM8 7.00333C9.43333 7.21333 10.93 8.21333 11 10.0033H8V7.00333ZM21 7.00333V9.00333H13V7.00333H21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.07965cbe51e70fb3f24b3e8c7b4eca4a.svg";
export { ForwardRef as ReactComponent };